const state = {
  video_id: null,
  video_type: "youtube",
  video_show: false,
};
const mutations = {
  closeVideoPopup(state) {
    state.video_show = false;
  },
  writeVideoId(state, video_id, video_type) {
    // video_id = short youtube id
    // video_type = is vk or youtube
    state.video_id = video_id;
    state.video_type = video_type;
  },
  showVideoPopup(state) {
    state.video_show = true;
  },
};
const getters = {
  getVideoPopupStatus(state) {
    return state.video_show;
  },
  getVideoPopupVideoLink(state, getters) {
    return state.video_type === "vk" ? getters.getVideoVkLink : getters.getVideoYouTubeLink;
  },
  getVideoVkLink(state) {
    let code = state.video_id.split("_");
    return `https://vkvideo.ru/video_ext.php?oid=${code[0]}&id=${code[1]}&hash=${code[2]}&hd=2`;
  },

  getVideoYouTubeLink() {
    return `https://www.youtube.com/embed/${state.video_id}?autoplay=1&rel=0&showinfo=0`;
  },
};
const store = {
  namespaced: true,
  state,
  mutations,
  getters,
};
export default store;
